<template>
  <div>
    <div class="multiple-airports-tag">
      <div>
        <b-tooltip multilined type="is-light" :position="position">
          <b-tag type="is-default" class="is-small">
           
            <b-icon
            size="is-small"
                icon="airplane"
                custom-class="mdi-rotate-315"
              ></b-icon>
            NDC Fare
          </b-tag>
          <template v-slot:content>
            <h5 class="is-size-7 has-text-weight-bold has-text-left mb-1">
              Airline Direct (NDC) Fare
            </h5>
          </template>
        </b-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NDCTag",
  props: {
    type: String,
    position: {
      type: String,
      default: "is-bottom",
    },
  },
  data() {
    return {
      // active: false,
    };
  },
  mounted() {},
  methods: {},
  computed: {},
};
</script>

<style scoped></style>
